import { assetQuery, sanityFetch } from '../services/sanity';
// ---------- FUNCTIONS ----------
export const getCrafts = async (config) => {
    const results = await sanityFetch(config, `*[
    _type == "spacecraft"
    && !(_id in path("drafts.**"))
  ] ${craftQuery}`);
    return results;
};
export const deriveCraftMap = (crafts) => {
    if (!crafts) {
        return new Map();
    }
    const craftMap = new Map();
    crafts.forEach((craft) => {
        if (!craft.title) {
            return;
        }
        craftMap.set(craft.title, craft);
    });
    return craftMap;
};
// ---------- QUERIES ----------
export const craftQuery = `{
  _id,
  title,
  slug,
  shortDescription,
  heroImage ${assetQuery},
  blackIcon ${assetQuery},
  whiteIcon ${assetQuery},
  filledBlackIcon ${assetQuery},
  filledVerticalIcon ${assetQuery},
  sideBitmap ${assetQuery},
  topBitmap ${assetQuery},
  bottomBitmap ${assetQuery},
  sideSilhouette ${assetQuery},
  topSilhouette ${assetQuery},
  bottomSilhouette ${assetQuery},
  sideSilhouetteColored ${assetQuery},
  topSilhouetteColored ${assetQuery},
  bottomSilhouetteColored ${assetQuery},
  sideHoverBoundary ${assetQuery},
  topHoverBoundary ${assetQuery},
  bottomHoverBoundary ${assetQuery},
}`;
//# sourceMappingURL=crafts.js.map